import React from "react";
import HeaderSpacer from '../components/HeaderSpacer';
import ComparisonChart from '../components/ComparisonChart';
import styled from 'styled-components';
import AdditionalServicesCard from '../components/AdditionalServicesCard';

function Services() {
  const Services = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
    h2 {
      text-align: center;
    }
  `;
  return (
    <Services>
      <HeaderSpacer/>
      <h2>Packages</h2>
      <ComparisonChart/>
      <h2>Additional Services</h2>
      <AdditionalServicesCard/>
    </Services>
  );
}

export default Services;
